import _ from 'lodash';

export const lodash = {
  noop: _.noop,

  isFunction: _.isFunction,
  isArray: _.isArray,
  isPlainObject: _.isPlainObject,
  isString: _.isString,
  isNumber: _.isNumber,
  isUndefined: _.isUndefined,
  isNil: _.isNil,
  isNaN: _.isNaN,
  isEmpty: _.isEmpty,
  isInteger: _.isInteger,
  isBoolean: _.isBoolean,
  isDate: _.isDate,

  isEqual: _.isEqual,

  debounce: _.debounce,

  toString: _.toString,
  toNumber: _.toNumber,
  trim: _.trim,
  kebabCase: _.kebabCase,

  random: _.random,
  round: _.round,

  has: _.has,
  get: _.get,
  set: _.set,
  unset: _.unset,
  values: _.values,
  omit: _.omit,
  pick: _.pick,
  pickBy: _.pickBy,

  clone: _.clone,
  assign: _.assign,
  merge: _.merge,
  map: _.map,
  mapValues: _.mapValues,
  sumBy: _.sumBy,

  range: _.range,
  sampleSize: _.sampleSize,

  keyBy: _.keyBy,

  forEach: _.forEach,
  filter: _.filter,
  sortBy: _.sortBy,
  compact: _.compact,

  uniqueId: _.uniqueId,
};
